import styles from "../AudioRecorder.module.scss";
import AudioSessionInfo from "../audioSessionInfo/AudioSessionInfo";
import getClasses from "utils/getClasses";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import NotesPanel from "components/video-chat/components/notes-panel/NotesPanel";
import { isMobileOnly } from "react-device-detect";
import BackupWarning from "./BackupWarning";
import InPersonControls from "./InPersonControls";
import ExternalModeControls from "./ExternalModeControls";

const ExternalAndInPersonModeRecorder = ({
  appointment,
  showNotesPanel,
  isBackupWarningDismissed,
  setIsBackupWarningDismissed,
  recordingError,
  mode,
  isRecordingFinished,
  isRecordingStarted,
  isPaused,
  recordingTimeString,
  mediaRecorderRef,
  setIsPaused,
  patientAudioSource,
  setPatientAudioSource,
  setShowBrowserErrorBanner,
  setShowNotesPanel,
  initializedStreaming,
  startStreaming,
  getCurrentInputVolume,
}) => {
  const { isPhonePortrait } = usePhonePortraitContext();

  return (
    <div
      className={`${styles["audio-recorder__center-section-wrapper"]} ${
        showNotesPanel ? styles["second-open"] : ""
      }`}
    >
      <div className={styles["audio-recorder__no-notes-container"]}>
        <AudioSessionInfo appointment={appointment} />

        {!isBackupWarningDismissed && (
          <BackupWarning onDismiss={() => setIsBackupWarningDismissed(true)} />
        )}

        <div className={styles["audio-recorder__center-section-container"]}>
          <div
            className={getClasses(
              isPhonePortrait
                ? styles["audio-recorder__center-section--phone"]
                : styles["audio-recorder__center-section"],
              showNotesPanel ? styles["side-panel-open"] : "",
            )}
          >
            {mode === "in-person" && (
              <InPersonControls
                appointment={appointment}
                recordingError={recordingError}
                isPaused={isPaused}
                isRecordingFinished={isRecordingFinished}
                isRecordingStarted={isRecordingStarted}
                mediaRecorderRef={mediaRecorderRef}
                setIsPaused={setIsPaused}
                getCurrentInputVolume={getCurrentInputVolume}
                recordingTimeString={recordingTimeString}
              />
            )}

            {mode === "external" && (
              <ExternalModeControls
                isRecordingStarted={isRecordingStarted}
                isRecordingFinished={isRecordingFinished}
                isPaused={isPaused}
                patientAudioSource={patientAudioSource}
                setPatientAudioSource={setPatientAudioSource}
                setShowBrowserErrorBanner={setShowBrowserErrorBanner}
                initializedStreaming={initializedStreaming}
                startStreaming={startStreaming}
                recordingTimeString={recordingTimeString}
                mediaRecorderRef={mediaRecorderRef}
                setIsPaused={setIsPaused}
              />
            )}
          </div>
        </div>
      </div>

      {showNotesPanel && appointment && (
        <div
          className={
            !isMobileOnly
              ? styles["audio-recorder__side-panel"]
              : styles["audio-recorder__side-panel--phone"]
          }
        >
          <NotesPanel
            close={() => setShowNotesPanel(false)}
            currOrchidProId={appointment.orchid_pro.cognito_sub}
            patientId={appointment.patient.orchid_user_id}
            appointmentId={String(appointment.appointment_id)}
          />
        </div>
      )}
    </div>
  );
};

export default ExternalAndInPersonModeRecorder;
